import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map, merge } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { HttpCall } from 'src/app/services/httpcall.service';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { commonNetworkAttachmentViewer, gallery_options, MMDDYYYY } from 'src/consts/utils';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatMenuTrigger } from '@angular/material/menu';
import { SeoService } from 'src/app/seo.service';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { NgxGalleryComponent, NgxGalleryImage, NgxGalleryModule, NgxGalleryOptions } from 'ngx-gallery-15';
import { CommonComponentsService } from '../common-components.service';
import { PortalTicketModel, TicketModel } from '../common-components.model';
import { httpVersion, httpRoutes } from 'src/consts/http-routes';
import { WEB_ROUTES } from 'src/consts/routes';
import { LoadingComponent } from '../loading/loading.component';
import { MatTableModule } from '@angular/material/table';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { PhoneFormatPipe } from '../common.pipe';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: ['./ticket-list.component.scss'],
  imports: [LoadingComponent, NgxGalleryModule, MatPaginatorModule, TranslateModule, MatTableModule, CommonModule, DatePipe, MatTooltipModule, MatIconModule, PhoneFormatPipe, MatButtonModule]
})
export class TicketListComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  displayedColumns = ['user_name', 'status', 'portal_key', 'created_at', 'updated_at', 'Ticket_Information', 'priority', 'attachment'];
  ticketService?: CommonComponentsService;
  dataSource!: any;
  isDelete = 0;
  id: any;
  ticketList!: PortalTicketModel[];
  @ViewChild('gallery') gallery!: NgxGalleryComponent;
  imageObject: Array<string> = [];
  galleryImages: NgxGalleryImage[] = [];
  galleryOptions!: NgxGalleryOptions[];
  tmp_gallery: any;
  isCardClicked = false;
  isCloseCardClicked = false;
  isOnholdCardClicked = false;
  isEscalatedCardClicked = false;
  isWatingCardClicked = false;

  ticket_count: any = {
    Open: 0,
    Closed: 0,
    Onhold: 0,
    Escalatedto3rdtier: 0,
    Waitingforcustomer: 0
  };

  tableRequest = {
    pageIndex: 0,
    pageSize: 10,
    search: '',
    sort: {
      field: 'created_at',
      order: 'desc'
    }
  };
  pager: any = {
    first: 0,
    last: 0,
    total: 0,
  };
  cardStatus!: string;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild('filter', { static: true }) filter!: ElementRef;
  @ViewChild(MatMenuTrigger)
  contextMenu?: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };
  rform: any;
  fb: any;
  header_image: any;

  constructor(private seo: SeoService, public httpClient: HttpClient, public dialog: MatDialog, private snackBar: MatSnackBar,
    public route: ActivatedRoute, private router: Router, private httpCall: HttpCall, private commonService: CommonService,
    public translate: TranslateService, public uiSpinner: UiSpinnerService) {
    super();
    this.seo.setTags({
      title: 'Portal Ticket List', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay Ticket Listing', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });
    this.tmp_gallery = gallery_options();
    this.tmp_gallery.actions = [
      {
        icon: 'fas fa-download',
        onClick: this.downloadButtonPress.bind(this),
        titleText: 'download',
      },
    ];
    this.galleryOptions = [this.tmp_gallery];


    this.translate.stream([""]).subscribe(() => {
      if (localStorage.getItem(localStorageConstants.DARKMODE) === 'dark') {
        // Dark Header
        if (localStorage.getItem(localStorageConstants.LANGUAGE) == 'es') {
          // Spanish Header
          this.header_image = "assets/header_images/dark_mode_es/dark_support_ticket_es.png";
        } else {
          // English Header
          this.header_image = "assets/header_images/dark_mode/dark_support_ticket.png";
        }
      } else {
        // Light Header
        if (localStorage.getItem(localStorageConstants.LANGUAGE) == 'es') {
          // Spanish Header
          this.header_image = "assets/header_images/light_mode_es/light_support_ticket_es.png";
        } else {
          // English Header
          this.header_image = "assets/header_images/light_mode/light_support_ticket.png";
        }

      }
    });
  }

  ngAfterViewInit() {
    this.translate.stream([""]).subscribe(() => {
      this.translateTable();
    });
  }

  translateTable() {
    let that = this;
    this.translate.get('COMMON.TOOL_TIP.ITEMS_PER_PAGE').subscribe((translation: string) => {
      that.paginator._intl.itemsPerPageLabel = translation;
    });
    this.loadData();
  }

  ngOnInit() {
    this.getAllCount();
    this.loadData();
  }

  refresh() {
    this.loadData();
  }

  open() {
    this.isCloseCardClicked = false;
    this.isOnholdCardClicked = false;
    this.isEscalatedCardClicked = false;
    this.isWatingCardClicked = false;

    if (this.cardStatus == "Open") {
      this.cardStatus = "";
    } else {
      this.cardStatus = "Open";

    }
    this.isCardClicked = !this.isCardClicked;
    this.refresh();
  }

  close() {
    this.isCardClicked = false;
    this.isOnholdCardClicked = false;
    this.isEscalatedCardClicked = false;
    this.isWatingCardClicked = false;

    if (this.cardStatus == "Closed") {
      this.cardStatus = "";
    } else {
      this.cardStatus = "Closed";
    }
    this.isCloseCardClicked = !this.isCloseCardClicked;
    this.refresh();
  }

  onhold() {
    this.isCardClicked = false;
    this.isCloseCardClicked = false;

    this.isEscalatedCardClicked = false;
    this.isWatingCardClicked = false;

    if (this.cardStatus == "On hold") {
      this.cardStatus = "";
    } else {
      this.cardStatus = "On hold";
    }
    this.isOnholdCardClicked = !this.isOnholdCardClicked;
    this.refresh();
  }

  escalatedto3rdtier() {
    this.isCardClicked = false;
    this.isCloseCardClicked = false;
    this.isOnholdCardClicked = false;

    this.isWatingCardClicked = false;

    if (this.cardStatus == "Escalated to 3rd tier") {
      this.cardStatus = "";
    } else {
      this.cardStatus = "Escalated to 3rd tier";
    }
    this.isEscalatedCardClicked = !this.isEscalatedCardClicked;
    this.refresh();
  }

  waitingforcustomer() {
    this.isCardClicked = false;
    this.isCloseCardClicked = false;
    this.isOnholdCardClicked = false;
    this.isEscalatedCardClicked = false;

    if (this.cardStatus == "Waiting for customer") {
      this.cardStatus = "";
    } else {
      this.cardStatus = "Waiting for customer";
    }
    this.isWatingCardClicked = !this.isWatingCardClicked;
    this.refresh();
  }

  public changePage(e: any) {
    this.tableRequest.pageIndex = e.pageIndex;
    this.tableRequest.pageSize = e.pageSize;
    this.loadData();
  }

  // View Network Attachment
  viewAttachment(ticket: PortalTicketModel) {
    this.imageObject = ticket.attachment;
    this.galleryImages = commonNetworkAttachmentViewer(this.imageObject);
    setTimeout(() => {
      this.gallery.openPreview(0);
    }, 0);
  }
  downloadButtonPress(event: any, index: number): void {
    window.location.href = this.imageObject[index];
  }
  onSearchChange(event: any) {
    this.tableRequest.search = event.target.value;
    this.tableRequest.pageIndex = 0;
    this.loadData();
  }
  sortData(event: any) {
    if (event.direction == '') {
      this.tableRequest.sort.field = 'created_at';
      this.tableRequest.sort.order = 'desc';
    } else {
      this.tableRequest.sort.field = event.active;
      this.tableRequest.sort.order = event.direction;
    }
    this.loadData();
  }


  loadData() {
    this.ticketService = new CommonComponentsService(this.httpCall);
    const displayDataChanges = [
      this.ticketService.ticketdataChange,
      this.ticketService.ticketPager,
      this.sort.sortChange,
      this.paginator.page,
    ];
    this.ticketService.getTicketTable({ is_delete: this.isDelete, start: this.tableRequest.pageIndex * 10, length: this.tableRequest.pageSize, search: this.tableRequest.search, sort: this.tableRequest.sort, status: this.cardStatus });

    this.dataSource = merge(...displayDataChanges).pipe(
      map(() => {
        this.ticketList = this.ticketService?.TicketData || [];
        this.pager = this.ticketService?.TicketPagerData;
        return this.ticketService?.TicketData.slice();
      })
    );
  }

  // context menu
  onContextMenu(event: MouseEvent, item: PortalTicketModel) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    if (this.contextMenu !== undefined && this.contextMenu.menu !== null) {
      this.contextMenu.menuData = { item: item };
      this.contextMenu.menu.focusFirstItem('mouse');
      this.contextMenu.openMenu();
    }
  }

  back() {
    this.router.navigate([WEB_ROUTES.SIDEMENU_DASHBOARD], { queryParams: { _id: this.id } });
  }

  addTicket() {
    this.router.navigate(['portal-ticket-form']);
  }

  editTicket(client: PortalTicketModel) {
    this.router.navigate(['portal-ticket-form'], { queryParams: { _id: client._id } });
  }

  async getAllCount() {
    try {
      const data = await this.commonService.getRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.PORTAL_GET_ALL_STATUS_COUNT);
      if (data.status) {
        this.ticket_count = data.data;
      } else {
        this.ticket_count = 0;
      }
    } catch (error) {
      console.error('Error fetching ticket count:', error);
      // Handle error condition here (e.g., setting default value for ticket_count)
      this.ticket_count = 0;
    }
  }

  MMDDYYYY_format_tmp(data: any) {
    return MMDDYYYY(data);
  }
  //Tooltip
  getNameTooltip(row: TicketModel) {
    return row.user_name;
  }

  getApplicationTooltip(row: TicketModel) {
    return row.portal_key;
  }

  getStatusTooltip(row: TicketModel) {
    return row.status;
  }

}
